import {
  lazy,
  type ComponentType,
  type LazyExoticComponent,
} from "react";

class RouteResourceError extends Error {
  constructor(cause: unknown) {
    super("ROUTE_RESOURCE_LOAD_FAILED", { cause });
    this.name = "RouteResourceError";
  }
}

export function isRouteResourceError(error: Error): boolean {
  return error instanceof RouteResourceError;
}

export function lazyRoute<T extends ComponentType<object>>(
  loader: () => Promise<{ default: T }>,
): LazyExoticComponent<T> {
  return lazy(async () => {
    try {
      return await loader();
    } catch (error) {
      throw new RouteResourceError(error);
    }
  });
}
